import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTable, usePagination, useSortBy } from 'react-table';
import caretDown from '../../images/icons/caretDown.svg';
import Loader from '../common/Loading';
import Pagination from '../common/Pagination';

const PoTable = ({ columnHeaders, tableData, isLoading,
  isError, hasNext, currentPage, isCrewPage, isAgencyPage,
  hasPrev,
  totalItems,
  totalPages }) => {
  const pageNo = useSelector((state) => state.page.pageNo);
  const pageNoSize = useSelector((state) => state.page.pageSize);
  const dispatch = useDispatch();

  const columns = useMemo(() => {
    if (!isCrewPage || isAgencyPage) {
      return columnHeaders.filter(
        (col) => col.Header !== 'Crew Name' && col.Header !== 'Crew Code'
      );
    }
    return columnHeaders;
  }, [isCrewPage, isAgencyPage, columnHeaders]);
  const data = React.useMemo(
    () => tableData,
    [tableData]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize }
  } = useTable(
    {
      columns,
      data,
      autoResetPage: false,
      initialState: { pageIndex: pageNo, pageSize: pageNoSize }
    },
    useSortBy,
    usePagination
  );
  if (isError) {
    return (
      <>
        Something Went Wrong !!
      </>
    );
  }

  if (isLoading) {
    <Loader message="Loading" />;
  }

  return (
    <>
      {isLoading ? <Loader />
        : (
          <div className="">
            <div
            className="data-table-height overflow-auto po-table-modified"
            >
              <table {...getTableProps()} className="table table-auto mx-auto" key={isAgencyPage ? 'agency' : (isCrewPage ? 'crew' : 'vessel')}>
                <thead
                className="sticky-element"
                >
                  {headerGroups.map((headerGroup) => {
                    return (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => {
                          return (
                            <th
                              className="text-left capitalize px-4 py-3"
                              {...column.getHeaderProps(column.getSortByToggleProps())}
                            >
                              <span className="font-bold text-sm text-gray-500 ">

                                {column.render('Header')}
                              </span>
                              {column?.canSort && (
                        <span>
                          <img src={caretDown} alt="caretDown" className={`${column.isSorted ? 'transform rotate-180' : ''} inline-block p-1`} />
                        </span>
                        )}
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                <tbody {...getTableBodyProps()} className="h-10">
                  {
                   totalItems > 0 && (
                      <>
                        {rows.map((row) => {
                          prepareRow(row);
                          return (
                            <tr className="tr" {...row.getRowProps()}>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td
                                    className="px-4 overflow-visible"
                                    {...cell.getCellProps()}
                                  >
                                    <span
                                    className={`text-sm font-muli ml-auto
                               ${index > 0 ? 'text-gray-500' : 'text-gray-500'} 
                              ${cell.column.Header === 'status' ? 'inprogress rounded-full px-4 py-1' : ''}
                              `}
                                    >
                                      {cell.render('Cell')}
                                    </span>
                                    {' '}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </>
                    )
                  }
                </tbody>
              </table>
              {totalItems <= 0 && (
                <h1 className="text-gray-500 text-sm">No Data Available</h1>
              )}
            </div>

            <Pagination
              {...{
                previousPage,
                canPreviousPage: hasPrev,
                gotoPage,
                totalPages,
                setPageSize,
                nextPage,
                rowCount: [25, 50, 100, 500],
                canNextPage: hasNext,
                currentPage,
                pageSize,
                dispatch
              }}
            />

          </div>
        )}
    </>
  );
};
export default PoTable;
